import apiClient from './client';
import { ErrorLog, PageResponse } from '../types';

export const logsApi = {
  getLogs: (page = 0, size = 50) =>
    apiClient
      .get<PageResponse<ErrorLog>>('/v1/logs', { params: { page, size } })
      .then((r) => r.data),
};
